import React from 'react'
import './banner.css'

const banner = () => {
    return (
        <div className="main-banner">
            <div className="main-banner-centered">
                <h2 className="main-banner-h2">Nine Forty Air Cargo</h2>
                <h4 className="main-banner-h4">
                    Big to Deliver Small to Listen
                </h4>
            </div>
        </div>
    )
}

export default banner
